module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/experts_desktop-acf3b7479e8e05cfd63503ba1c1a08bd.png";